<template>
	<div class="add_backimg add_backimgTop clearfix">
		<div class="nav_list">
			<span class="primaryColor"><i class="el-icon-location-outline"></i>当前位置：</span>
			<span class="pointer" @click="toName('index')">首页<i class="el-icon-arrow-right"></i></span>
			<span class="pointer" @click="toName('examinelist')">考试中心<i class="el-icon-arrow-right"></i></span>
			<span>开始考试</span>
		</div>
		<div class="content minheight exam_infoCont clearfix">
			<img src="@/images/exam_back.png" class="exam_back" />
			<img src="@/images/exam_title.png" class="exam_title" />
			<div class="exam_titleText">{{taskinfo.name}}</div>
			<div class="exam_infoMain">
				<img src="@/images/exam_mainBack.png" class="exam_mainBack" />
				<img src="@/images/exam_mainIcon.png" class="exam_mainIcon" />
				<div class="exam_infoDesc clearfix">
					<div class="exam_infoUser">
						<div class="exam_userIcon coverItem">
							<img :src="baseurl + userinfo.iconurl" v-if="userinfo.iconurl" />
							<img src="@/images/1.png" v-if="!userinfo.iconurl" />
						</div>
						<div class="exam_userName text-ellipsis">{{userinfo.name}}</div>
						<div class="exam_userNum text-ellipsis">学号：{{userinfo.username || '-'}}</div>
					</div>
					<div class="exam_paper">
						<div class="exam_paperInfo"><img src="@/images/exam_paperInfo1.png" />总题目：{{topicinfo.topicAmount}}道</div>
						<div class="exam_paperInfo"><img src="@/images/exam_paperInfo2.png" />总分：{{topicinfo.totalScore}}分 </div>
						<div class="exam_paperInfo"><img src="@/images/exam_paperInfo3.png" />时长：{{taskinfo.timeSpent}}分钟</div>
						<div class="exam_paperInfo"><img src="@/images/exam_paperInfo4.png" />截止日期：{{taskinfo.endTime | spliceForTask}}</div>
					</div>
				</div>
				<div class="exam_infoTips">
					<i class="el-icon-warning"></i> 开始答题后，请勿中途退出、关闭、切换系统，提交试卷后可进行关闭
					<br /> 若电脑卡机或电脑关机等原因，致使考试中途退出，可重新登录继续进行考试
				</div>
			</div>
			<div class="exam_infoBtns">
				<el-button type='warning' @click='$router.back(-1)' v-if="false">退出</el-button>
				<el-button type='primary' @click='toExamine'>开始答题</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import { getExamineById, addExamRecord, getUserAnswerList, answer, commit } from '@/api/examine.js'
	import { topicByPaperId } from '@/api/paper.js'
	import { getInfo } from '@/api/user.js'
	export default {
		data() {
			return {
				id: this.$route.query.id,
				userinfo: {},
				paperId: '',
				loading: true,
				newanswer: false,
				isSubjectiveItem: false,
				loadingtext: '题目加载中...',
				questionindex: 0,
				questionove: [],
				qusetionlist: [],
				taskinfo: {},
				topicinfo: {},
				hours: '00',
				minutes: '00',
				seconds: '00',
				timelen: 900000, //15分钟
				timelaster: null,
				timeread: 5,
				timereader: null,
				userExamId: '',
				uploadFlag: false,
			}
		},
		created() {
			this.getMyInfo();
			this.getTaskitem();
		},
		methods: {
			getMyInfo() {
				getInfo().then(res => {
					this.userinfo = res.data;
				})
			},
			getTaskitem() {
				var data = {
					id: this.id
				}
				getExamineById(data).then(res => {
					if(res.code == "OK" && res.data) {
						this.taskinfo = res.data;
						this.timelen = res.data.timeSpent * 60 * 1000;
						res.data.paperList.map(item => {
							if(item.isUsing == '1') {
								this.paperId = item.id;
								this.topicinfo = item;
							}
						})
						this.getTaskinfo();
						this.startAnswer();
					}
				})
			},
			getTaskinfo() {
				var data = {
					id: this.paperId
				}
				topicByPaperId(data).then(res => {
					if(res.code == "OK") {
						this.qusetionlist = res.data;
					}
				})
			},

			startAnswer() {
				var data = {
					examineId: this.id,
					paperId: this.paperId,
				}
				addExamRecord(data).then(res => {
					if(res.data.state == 0 || res.data.state == 3) {
						this.getIshave();
					}
					if(res.data.state == 1) {
						this.$alert('此次考试您已交卷，请勿重复作答', '提示', {
							confirmButtonText: '确定',
						}).then(() => {
							this.$router.back(-1);
						}).catch(() => {
							this.$router.back(-1);
						})
					}
				})
			},
			getIshave() {
				this.newanswer = true;
				var timeread = this.timeread;
				var timereader = setInterval(_ => {
					timeread--
					this.timeread = timeread;
					if(timeread <= 0) {
						clearInterval(timereader);
						this.timereader = null;
					}
				}, 1000);
				this.timereader = timereader;
			},
			exitExam() {
				this.$router.back(-1);
			},
			toExamine(item) {
				this.$router.push({
					name: 'examine',
					query: {
						id: this.id
					}
				})
			},
			toName(name) {
				if(this.$router.name != name) {
					this.$router.push({
						name: name
					})
				}
			},
		},
		beforeRouteLeave(to, from, next) {
			var timereader = this.timereader;
			if(timereader) {
				clearInterval(timereader);
				this.timereader = null;
			}
			var timelaster = this.timelaster;
			if(timelaster) {
				clearInterval(timelaster);
				this.timelaster = null;
			}
			next();
		},
	}
</script>